import React from 'react'
import centerIcon from "../../../img/icon/icon-center.svg";
import changeIcon from "../../../img/icon/icon-us-change.svg";
import { GetShotDateString, PassedMonths,GetChildrenState } from "../../../components/common/Common";

const TopChildrenStatus = ({varClasses,varChildrenInfo,varChildrenList,onChangeChildrenHandler}) => {
  return (
    <div className={varClasses}>
      <div className="us-name">{varChildrenInfo.ch_name}</div>
      <div className="us-con">
        <div className="us-top">
          <img src={centerIcon} alt=""/>
          <p>{varChildrenInfo.bh_company}</p>
        </div>
        <div className="us-bt">{PassedMonths(varChildrenInfo.ch_birthday)}개월 ({GetShotDateString(varChildrenInfo.ch_birthday)}) - {GetChildrenState(varChildrenInfo.ch_status)}</div>
      </div>
      {varChildrenList.length===1?null:<button type="button" className="us-change" onClick={e=>onChangeChildrenHandler(e)}><img src={changeIcon} alt=""/></button>}
    </div>
  )
}
export default TopChildrenStatus;